// extracted by mini-css-extract-plugin
module.exports = {"root":"CardDetail_root__1yLGq","icon":"CardDetail_icon__LBODj","last4":"CardDetail_last4__1-bBE","brand":"CardDetail_brand__35w5B"};